@if (wrapper && wrapper.isReady) {
  <div [class]="accClass">
    <div class="d-flex gap-2 align-items-lg-end flex-fill">
      <div class="flex-fill">
        <acc-form-typeahead #typeahead [name]="name" [wrapper]="wrapper" type="select"
                            (accChanged)="accChanged.emit($event)" [config]="typeaheadConfig"/>
      </div>
      @if (allowAddContact()) {
        <div class="align-self-end">
          <acc-button class="action" [accClass]="getAddButtonClass()" [size]="config.size"
                      [ngbTooltip]="'contact.new'|translate"
                      (accClick)="addNewContact()">
            <acc-icon name="add"/>
          </acc-button>
        </div>
      } @else if (isViewOnly() && isContact()) {
        <div class="align-self-end form-group">
          <a class="contact-view-action" (click)="goToContact()" (keydown.enter)="goToContact()" tabindex="0">
            <acc-icon name="contact"/>
          </a>
        </div>
      }
    </div>
    @if (config.employeeTypeSelectShow && nameEmployeeType) {
      <div class="flex-fill">
        <acc-form-select [name]="nameEmployeeType" [wrapper]="wrapper"/>
      </div>
    }
  </div>
}
